import React from "react";

const LocationIcon = props => (
  <svg
    style={props.style}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M19.427 11.463c.212-.85.323-1.672.323-2.463a7.75 7.75 0 00-15.5 0c0 .791.11 1.613.323 2.463.539 2.154 1.706 4.422 3.313 6.717a37.006 37.006 0 003.267 4.022c.15.158.257.268.317.328a.75.75 0 001.06 0c.06-.06.168-.17.317-.328a37.008 37.008 0 003.268-4.022c1.606-2.295 2.773-4.563 3.312-6.717zm-4.541 5.857A35.512 35.512 0 0112 20.91a35.506 35.506 0 01-2.886-3.59c-1.51-2.158-2.599-4.273-3.086-6.22A8.678 8.678 0 015.75 9a6.25 6.25 0 1112.5 0c0 .662-.094 1.363-.278 2.1-.487 1.947-1.576 4.062-3.086 6.22zM12 12.75a3.75 3.75 0 110-7.5 3.75 3.75 0 010 7.5zM14.25 9a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
      clipRule="evenodd"
    />
  </svg>
);

export default LocationIcon;



// WEBPACK FOOTER //
// ./src/icons/LocationIcon.jsx